import { TakeActionDropdownData } from 'components/TakeActionDropdown/types/TakeActionDropdownData';
import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';

export const takeActionDropdownDataEn: TakeActionDropdownData = {
  search: {
    title: 'Search',
    items: [
      {
        type: 'volop',
        title: 'Volunteer',
        href: getMainVolopsSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'event',
        title: 'Attend an Event',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['EVENT'] },
        }),
      },
      {
        type: 'donations',
        title: 'Give Donations',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['DONATION'] },
        }),
      },
      {
        type: 'petitions',
        title: 'Sign Petitions',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['PETITION'] },
        }),
      },
      {
        type: 'loans',
        title: 'Make a Loan',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['LOAN'] },
        }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        type: 'idealist-movement',
        title: 'Join the Idealist Action Incubator',
        description:
          'Connect with a member of our team for one-on-one sessions where you’ll collaboratively develop your action plan.',
        href: '/en/action-incubator',
      },
    ],
  },
};
